var styleDataHash = 'ffc19e64';  
export const injectCss = (() => {
  var css = `.GnI-n{border:0;height:100%;width:100%;z-index:0}.GnI-n,.RVlAP{left:0;position:absolute;top:0}.RVlAP{bottom:0;right:0;z-index:3}.cZjzn{height:0;padding-bottom:56.25%;position:relative}@supports not (contain:inline-size){@media only screen and (max-width:480px){.cZjzn{min-width:auto}}}@container (width < 480px){.cZjzn{min-width:auto}}.Berpf{display:block!important;margin:0}.glob_fontElementMap,.uoMM6{font-family:var(--ricos-font-family,unset)}.Zuehd{--ricos-custom-p-font-size:14px;color:var(--ricos-custom-p-color,unset);display:block;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);justify-content:center;letter-spacing:var(--ricos-custom-p-letter-spacing,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-align:center;text-decoration:var(--ricos-custom-p-text-decoration,unset)}.Zuehd>span>a,.Zuehd>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:480px){.Zuehd{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 480px){.Zuehd{font-size:var(--ricos-custom-p-font-size,unset)}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





